import axios from 'axios';

let AchatImmobilier : any = {};
AchatImmobilier.submit= async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/bien/send/achat`, data)
}

export default AchatImmobilier;